import React, { useEffect, useState } from 'react';
import {
  Divider,
  Menu,
  Row,
  Col,
  Image,
  Typography,
  Radio,
  Space,
  Modal,
  Layout,
  Tabs,
  Button,
  Select,
  Switch,
  Popover,
} from "antd";
import { RightOutlined, LeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import "antd/dist/antd.min.css";

const { Title } = Typography;

const { Content } = Layout;

const { Option } = Select;


const API_URL = 'https://usg9llskyi.execute-api.eu-west-3.amazonaws.com/v1/find';
const S3_URL = 'https://histostargan.s3.eu-west-3.amazonaws.com/';


const getMenuItems = (data) => {
  let items = null;
  const folders = Object.keys(data);
  items = folders.map(folder => {

    if (typeof data[folder] === 'string') {
      return ({
        label: folder,
        key: data[folder],
      })
    }
    return ({
      label: folder,
      key: folder,
      children: getMenuItems(data[folder])
    })
  });


  return items;
}


function App() {
  const [menuItems, setMenuItems] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);

  const [galeryData, setGaleryData] = useState([]);

  const [f1, setF1] = useState('02');
  const [f2, setF2] = useState('glom');
  const [sorting, setSorting] = useState(false);

  const [filterResults, setFilterResults] = useState(new Array(30).fill(''));

  const [modalVisible, setModalVisible] = useState(false);
  const [previewSrc, setPreviewSrc] = useState(undefined);
  const [segPreviewImage, setSegPreviewImage] = useState(undefined);

  const [activeImageIdx, setActiveImageIdx] = useState(undefined);

  const [playgroundMenuItems, setPlaygroundMenuItems] = useState([]);
  const [currPlaygroundVideo, setCurrPlaygroundVideo] = useState(null);

  useEffect(() => {
    fetch(API_URL, {
      method: 'POST',
      body: JSON.stringify({
        'prefix': "Videos/"
      })
    }).then((response) => {

      return response.json();
    }).then((data) => {
      setMenuItems(getMenuItems(data.fileList));
      console.log('data = ', getMenuItems(data.fileList));
    });


    fetch(API_URL, {
      method: 'POST',
      body: JSON.stringify({
        'prefix': 'random'
      })
    })
      .then((response) => response.json())
      .then((data) => {
        setGaleryData(data.fileList);
      });


    fetch(API_URL, {
      method: 'POST',
      body: JSON.stringify({
        'prefix': 'Playground/',
      })
    }).then((response) => response.json())
    .then((data) => setPlaygroundMenuItems(getMenuItems(data.fileList)));

  }, []);

  useEffect(() => {

    setActiveImageIdx(undefined);
    setFilterResults(new Array(30).fill(''));

    fetch(API_URL, {
      method: 'POST',
      body: JSON.stringify({
        'prefix': `dataset/${f1}/${f2}/`
      })
    })
      .then((response) => response.json())
      .then((data) => {

        if (sorting) {
          setFilterResults(data.fileList);
        } else {
          setFilterResults(data.fileList.sort(() => .5 - Math.random()));
        }
      })
  }, [f1, f2, sorting]);

  useEffect(() => {

    if (activeImageIdx !== undefined) {
      const src = `${S3_URL}${filterResults[activeImageIdx]}`;
      setPreviewSrc(src);
      const segSrc = src
        .replace(/\/neg\//, '/seg/')
        .replace(/\/glom\//, '/seg/')
        .replace(/\/random\//, '/seg/')
        .replace(/_latent_/, '_seg_latent_');

      setSegPreviewImage(segSrc);
      setModalVisible(true);
    }
  }, [activeImageIdx, filterResults]);

  // const openImagePreview = (idx) => {
  //   setActiveImageIdx(idx);
  //   const src = `${S3_URL}${filterResults[idx]}`;

  //   setPreviewSrc(src);

  //   const segSrc = src
  //     .replace(/\/neg\//, '/seg/')
  //     .replace(/\/glom\//, '/seg/')
  //     .replace(/\/random\//, '/seg/')
  //     .replace(/_latent_/, '_seg_latent_');


  //   setSegPreviewImage(segSrc);
  //   setModalVisible(true);
  // }

  

  const showNext = () => {

    if (activeImageIdx < filterResults.length - 1) {
      setActiveImageIdx(activeImageIdx + 1);
    }
  }

  const showPrev = () => {
    if (activeImageIdx > 0) {
      setActiveImageIdx(activeImageIdx - 1);
    }
  }

  const popoverContent = (
    <>
      <ul>
        <li>All presented images in each staining (including PAS) are synthetic, generated by translating real PAS-stained images.</li>
        <li>The data has not been specifically selected or post-processed in any way; therefore, some images can contain artefacts.</li>
        <li>Selection criteria will be formulated upon consultation with pathologists in order to form as representative as possible dataset.</li>
      </ul>
    </>
  )

  return (


    <Layout>
      
      <Content style={{margin: '0 5%'}}>
        <Row justify='center' style={{paddingTop: '30px'}}>
          <Title level={1}>HistoStarGAN</Title>
        </Row>
        <Divider />

        <Row justify='center'>
          <Col span={6} align='center'>
            <b>Jelica Vasiljević</b><br/>
            ICube, University of Strasbourg, <br/> CNRS (UMR 7357), France <br/>
            University of Kragujevac, Kragujevac, Serbia <br/>
            jvasiljevic@unistra.fr
          </Col>
          <Col span={6} align='center'>
            <b>Friedrich Feuerhake</b> <br/>
            Institute of Pathology, Hannover Medical School, Germany<br />
            University Clinic, Freiburg, Germany<br/>
            Feuerhake.Friedrich@mh-hannover.de
          </Col>
          <Col span={6} align='center'>
            <b>Cédric Wemmert</b><br/>
            ICube, University of Strasbourg, <br/> CNRS (UMR 7357), France <br/>
            wemmert@unistra.fr
          </Col>
          <Col span={6} align='center'>
            <b>Thomas Lampert</b><br/>
            ICube, University of Strasbourg, <br/> CNRS (UMR 7357), France <br/>
            lampert@unistra.fr
          </Col>
        </Row>

        <Divider />

        <Row justify='center'>
          <Col span={6}></Col>
          <Col span={6} align='center'>
            <a href='' target='_blank' rel="noreferrer">PAPER</a>
          </Col>
          <Col span={6} align='center' >
            <a href='' target='_blank' rel="noreferrer">CODE</a>
          </Col> 
          <Col span={6}></Col>
        </Row>


        <Divider />
      </Content>
{/*       
        <Menu
          onClick={(e) => {
            console.log('event = ', e, e.key)
            setCurrentVideo(e.key)
          }}
          selectedKeys={[]}
          mode={'horizontal'}
          items={menuItems}
        />

        <video key={`${currentVideo}-top`} width="100%" height={400} controls autoPlay>
          <source src={`${S3_URL}${currentVideo}`} type="video/mp4" />
        </video>


        <Divider />
        <Title level={3}>Dataset</Title>


        <Row gutter={5}>
          {
            galeryData.slice(0, 48).map((image) => (
              <Col span={4} >
                <Image src={`${S3_URL}${image}`} />
              </Col>
            ))
          }
        </Row>

        <Divider />
        <Title level={3}>???</Title>


        <Row>
          <Col span={12}>
            <Radio.Group onChange={(event) => { console.log("event = ", event); setF1(event.target.value) }} value={f1}>
              <Space direction='vertical'>
                <Radio value={'02'}>02</Radio>
                <Radio value={'03'}>03</Radio>
                <Radio value={'16'}>16</Radio>
                <Radio value={'32'}>32</Radio>
                <Radio value={'39'}>39</Radio>
              </Space>
            </Radio.Group>
          </Col>
          <Col span={12}>
            <Radio.Group onChange={(event) => setF2(event.target.value)} value={f2}>
              <Space direction='vertical'>
                <Radio value={'glom'}>glom</Radio>
                <Radio value={'neg'}>neg</Radio>
                <Radio value={'random'}>random</Radio>
              </Space>
            </Radio.Group>
          </Col>
        </Row>

        <Row gutter={5}>
          {
            filterResults.map((image) => (
              <Col span={4} >
                <div style={{ cursor: 'pointer' }} onClick={() => openImagePreview(`${S3_URL}${image}`)}>
                  <Image
                    src={`${S3_URL}${image}`}
                    preview={false}
                    fallback={"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAEu0lEQVR4nO2c2W7bRhSGP0peGgMJ0mZ5g1wELfL+z1DbRZs0LZACzYXbOrZTp44cS1xmTi+Gam1LoSiKs9A5H+Abg8vx/OTZ5tCgKIqiKIqiKIqiKIqiKIryJZCtOqD4DQlhyF1l51nzGo9CGaIsRwWIjAoQGRUgMipAZFSAyKgAkVEBIqMCRGYrtgFtEAMyATsFKd3vsm0Y3YPsPmTjuPZtQvICyBWY9yC3GiJSgCkg+wjjx5DtxbFvU5J2QXIF1dni4t84RupjrsLZ1SfJCiDGPfltMX+7c4ZGugJMmp/8heOtO2doJCuA7eBS7LR/O3yzUgBzHsKMRaTqcFLZuxneWSmAnYA5ca94SFbuFPV2UlxauSA7g+pdx6eyK9sdzkk+qV6kfQwowRw7MUIwuhfmnNisFYTFOndkA2Qb2X3I1nAp2QiyB/7s8UWnLMic18HZ43Z9NnYVblvGj5wIQ6OzyXYC5sxvcM72YOtJ88Jmo/qYgbYiNgpbdgpyAltPAU8NsWwPxrsNzbgHw3zy52ycN0gB1V8wfgrZbh8mLZKNIXsIo4d+rh+TXp4dsVCdgL3s42pfFv29vOIaYr6D812jd+9pJ1C9BwJXzkPFS/iSK1c5E7JyHije8gcp6/ZF7usOdwOvCZyYOjh/8nmXYeM/gxa3s2X/8X6ntTEX7icmwfqH5gJsBVuPiN82FpetzdNmKePZFbSGlE/OJcXcu11Ws8S0K3gRLzlUx66CDn7vumpflhjEsitOF8XUGVLAURI7da10mp7yCHbFa2PV8zwhgvNanduAdkECm3jmwvne8Td4CYLmvNsGkm+75kQXAFxAlBLGT/qb8xQL9myzLVQfdt0mmU665LX/7WO0pMf9617tWkIyAgBQ1Qu3wYCVlwmOHuz6HGkJgBtHNGfd/LbPGaZN7GoiOQGA/yrV1lN5AvZDgCm+de1qQRJB+HPYCVDCqGFjXqQOtgHnQtvY1ZY034BrNPp0j755FX3FmuQFAJZmNTLzm520oodsaxgCcHMqz15CdZrGBxmbTgsmHQMWEJgdAiVsPyN+W/sa5rwu2r5mLbsGI4AYKF67VBDcBxy735HUX2AnQAWjx+2D8yBckMwgP/x/8cGNwMwO0/sqplXX9RrJC2A/wmx/uY+1l5AfgPkQ3q4mmvYdbpO0ANUJ5D80b5JIAcWPYN6Fs6sN8523VaQpgED51vn8NpmOWMhfQ/nGv2lr0WJCMKEQ5hALxS+1H12T8si99tvfDmdiOikBJIf8pfP7XalOXSDcfQHZV/3Z5otknhM7gdnBZot/41r7/VzLN0kIUJ26bEZ6/ABQijp17eDKQhJdgPIIileeevjz4PyWZEfmo8UAsVD8GiB9FCh/d8NX28/T+99CUQSQAoqfwxZQ1cm14OzpU6ouBHdBMavXpqo6FkEFSKF/I/liXykmwQQojyD/iSS+mhED+as6OEfGfwwQKN5A9Yf3O63HPDhPYec50fYW/ApQweylm1hIlerYDePuvIBsJ/z9vbkgO4XpftqLP8dc1IVghE+pvAhgz2H2/bD+k6GdwvTAJQoh6V2A6k+YJRJs16ZyiUJ5FNsQRVEURVEURVEURVEURVGUu8a/dYJmCMAkvFYAAAAASUVORK5CYII="}
                  />
                </div>
              </Col>
            ))
          }
        </Row>


        <Divider />
        <Title level={3}>Playground</Title>



        <Menu
          onClick={(e) => {
            console.log('event = ', e, e.key)
            setCurrPlaygroundVideo(e.key)
          }}
          selectedKeys={[]}
          mode={'horizontal'}
          items={playgroundMenuItems}
        />


        <video key={`${currPlaygroundVideo}-bottom`} width="100%" height={400} controls autoPlay>
          <source src={`${S3_URL}${currPlaygroundVideo}`} type="video/mp4" />
        </video> */}



      <Content style={{margin: '0 20%'}}>
        <Tabs defaultActiveKey='1'>

          <Tabs.TabPane tab="HistoStarGAN translations" key='1'>
            <Menu
              onClick={(e) => {
                console.log('event = ', e, e.key)
                setCurrentVideo(e.key)
              }}
              selectedKeys={[]}
              mode={'horizontal'}
              items={menuItems}
            />

            <video key={`${currentVideo}-top`} width="100%" height={400} controls autoPlay loop>
              <source src={`${S3_URL}${currentVideo}`} type="video/mp4" />
            </video>
          </Tabs.TabPane>

          {/* <Tabs.TabPane tab="Dataset overview" key='2'>
            <Row gutter={5}>
              {
                galeryData.slice(0, 48).map((image) => (
                  <Col span={4} >
                    <Image src={`${S3_URL}${image}`} />
                  </Col>
                ))
              }
            </Row>
          </Tabs.TabPane> */}
          <Tabs.TabPane
            tab={
              <div style={{ display: 'flex', flexDirection: 'row'  }}>
                KidneyArtPathology
                <Popover content={popoverContent}>
                  <div style={{margin: '0 5px'}}> <InfoCircleOutlined /> </div>
                </Popover>
              </div>
            } 
            key='3'>
            <Row style={{ margin: '15px 0 0 0' }}>
              <Col span={8}>
                Staining

                <Select 
                  onChange={(value) => setF1(value)}
                  style={{ width: '150px', margin: '0 15px' }}
                  value={f1}
                >
                  <Option value={'02'}>PAS</Option>
                  <Option value={'03'}>Jones H&E</Option>
                  <Option value={'16'}>CD68</Option>
                  <Option value={'32'}>Sirius Red</Option>
                  <Option value={'39'}>CD34</Option>
                </Select>
                {/* <Radio.Group onChange={(event) => {
                    console.log("event = ", event); 
                    setF1(event.target.value)
                  }} value={f1}>
                  <Space direction='vertical'>
                    <Radio value={'02'}>PAS</Radio>
                    <Radio value={'03'}>Jones H&E</Radio>
                    <Radio value={'16'}>CD68</Radio>
                    <Radio value={'32'}>Sirius Red</Radio>
                    <Radio value={'39'}>CD34</Radio>
                  </Space>
                </Radio.Group> */}
              </Col>
              <Col span={8}>
                Class
                <Select
                  onChange={(value) => setF2(value)}
                  value={f2}
                  style={{ width: '150px', margin: '0 15px' }}
                >
                  <Option value={'glom'}>Glomerulus</Option>
                  <Option value={'neg'}>Non-glomerulus</Option>
                  <Option value={'random'}>Random</Option>
                </Select>
                {/* <Radio.Group onChange={(event) => setF2(event.target.value)} value={f2}>
                  <Space direction='vertical'>
                    <Radio value={'glom'}>Glomerulus</Radio>
                    <Radio value={'neg'}>Non-glomerulus</Radio>
                    <Radio value={'random'}>Random</Radio>
                  </Space>
                </Radio.Group> */}
              </Col>
              <Col span={8}>
                Sorting <sup>*</sup>
                <Switch
                  style={{ margin: '0 15px'}}
                  checkedChildren={'Sorted'}
                  unCheckedChildren={'Random'}
                  value={sorting}
                  onChange={(value) => setSorting(value)}
                />
              </Col>
            </Row>
            <Row>
              <Col span={16}></Col>
              <Col span={8} style={{ fontSize: '10px' }}><sup>*</sup> Sorted view will show the translations with different styles next to each other</Col>
            </Row>

            <Row gutter={5}>
              {
                filterResults.map((image, idx) => (
                  <Col span={4} >
                    <div style={{ cursor: 'pointer' }} onClick={() => setActiveImageIdx(idx)}>
                      <Image
                        src={`${S3_URL}${image}`}
                        preview={false}
                        fallback={"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAEu0lEQVR4nO2c2W7bRhSGP0peGgMJ0mZ5g1wELfL+z1DbRZs0LZACzYXbOrZTp44cS1xmTi+Gam1LoSiKs9A5H+Abg8vx/OTZ5tCgKIqiKIqiKIqiKIqiKIryJZCtOqD4DQlhyF1l51nzGo9CGaIsRwWIjAoQGRUgMipAZFSAyKgAkVEBIqMCRGYrtgFtEAMyATsFKd3vsm0Y3YPsPmTjuPZtQvICyBWY9yC3GiJSgCkg+wjjx5DtxbFvU5J2QXIF1dni4t84RupjrsLZ1SfJCiDGPfltMX+7c4ZGugJMmp/8heOtO2doJCuA7eBS7LR/O3yzUgBzHsKMRaTqcFLZuxneWSmAnYA5ca94SFbuFPV2UlxauSA7g+pdx6eyK9sdzkk+qV6kfQwowRw7MUIwuhfmnNisFYTFOndkA2Qb2X3I1nAp2QiyB/7s8UWnLMic18HZ43Z9NnYVblvGj5wIQ6OzyXYC5sxvcM72YOtJ88Jmo/qYgbYiNgpbdgpyAltPAU8NsWwPxrsNzbgHw3zy52ycN0gB1V8wfgrZbh8mLZKNIXsIo4d+rh+TXp4dsVCdgL3s42pfFv29vOIaYr6D812jd+9pJ1C9BwJXzkPFS/iSK1c5E7JyHije8gcp6/ZF7usOdwOvCZyYOjh/8nmXYeM/gxa3s2X/8X6ntTEX7icmwfqH5gJsBVuPiN82FpetzdNmKePZFbSGlE/OJcXcu11Ws8S0K3gRLzlUx66CDn7vumpflhjEsitOF8XUGVLAURI7da10mp7yCHbFa2PV8zwhgvNanduAdkECm3jmwvne8Td4CYLmvNsGkm+75kQXAFxAlBLGT/qb8xQL9myzLVQfdt0mmU665LX/7WO0pMf9617tWkIyAgBQ1Qu3wYCVlwmOHuz6HGkJgBtHNGfd/LbPGaZN7GoiOQGA/yrV1lN5AvZDgCm+de1qQRJB+HPYCVDCqGFjXqQOtgHnQtvY1ZY034BrNPp0j755FX3FmuQFAJZmNTLzm520oodsaxgCcHMqz15CdZrGBxmbTgsmHQMWEJgdAiVsPyN+W/sa5rwu2r5mLbsGI4AYKF67VBDcBxy735HUX2AnQAWjx+2D8yBckMwgP/x/8cGNwMwO0/sqplXX9RrJC2A/wmx/uY+1l5AfgPkQ3q4mmvYdbpO0ANUJ5D80b5JIAcWPYN6Fs6sN8523VaQpgED51vn8NpmOWMhfQ/nGv2lr0WJCMKEQ5hALxS+1H12T8si99tvfDmdiOikBJIf8pfP7XalOXSDcfQHZV/3Z5otknhM7gdnBZot/41r7/VzLN0kIUJ26bEZ6/ABQijp17eDKQhJdgPIIileeevjz4PyWZEfmo8UAsVD8GiB9FCh/d8NX28/T+99CUQSQAoqfwxZQ1cm14OzpU6ouBHdBMavXpqo6FkEFSKF/I/liXykmwQQojyD/iSS+mhED+as6OEfGfwwQKN5A9Yf3O63HPDhPYec50fYW/ApQweylm1hIlerYDePuvIBsJ/z9vbkgO4XpftqLP8dc1IVghE+pvAhgz2H2/bD+k6GdwvTAJQoh6V2A6k+YJRJs16ZyiUJ5FNsQRVEURVEURVEURVEURVGUu8a/dYJmCMAkvFYAAAAASUVORK5CYII="}
                      />
                    </div>
                  </Col>
                ))
              }
            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Playground" key='4'>
              <Menu
                onClick={(e) => {
                  console.log('event = ', e, e.key)
                  setCurrPlaygroundVideo(e.key)
                }}
                selectedKeys={[]}
                mode={'horizontal'}
                items={playgroundMenuItems}
              />


              <video key={`${currPlaygroundVideo}-tabs`} width="100%" height={400} controls autoPlay loop>
                <source src={`${S3_URL}${currPlaygroundVideo}`} type="video/mp4" />
              </video>
          </Tabs.TabPane>

        </Tabs>


        <Modal
          visible={modalVisible}
          centered
          footer={null}
          width={'90%'}
          onCancel={() => { setModalVisible(false) }}
        >
          <Row type='flex' align='middle'>
            <Col span={2}>
              <Button onClick={showPrev}>
                <LeftOutlined />
              </Button>
            </Col>
            <Col span={10}>
              <Image width='100%' src={previewSrc} preview={false} />
            </Col>
            <Col span={10}>
              <Image width='100%' src={segPreviewImage} preview={false} />
            </Col>
            <Col align='center' span={2}>
                <Button onClick={showNext}>
                  <RightOutlined />
                </Button>
            </Col>
          </Row>
        </Modal>
      </Content>

    </Layout>
  );
}

export default App;
